//流量统计
import http from '@/axios/http'
export function listTraffic(data) {
    if (data.gid == '') {
        delete data.gid
    }
    return http({
        url: '/api/trafficManager/listTraffic',
        method: 'post',
        data
    })
}